<template>
  <div>
    <!-- <PerfectBtnSelect
      ref="skuTypeScope"
      :limitDataList="selectedSku"
      commonKey="sku"
      :showOperatingBtn="false"
      @deleteCheckbox="handleDeleteCheckbox"
      @setValue="getBonusBeerScope"
    >
      <div @click="handleShowDialog()">
        <i class="el-icon-plus add-btn"></i>
      </div>
    </PerfectBtnSelect>-->
    <div class style="display:flex;flex-wrap:wrap" v-if="type === 'bonusBeerSku'">
      <div class="btn-box" v-for="item,index in selectedSku" :key="index">
        <el-button size="mini" type="primary" class="exec-cycle-btn">{{item.skuName}}</el-button>
        <div class="delete-btn" @click="handleDeleteBtn(index, item)">
          <i class="el-icon-error"></i>
        </div>
      </div>

      <div @click="handleShowDialog()">
        <i class="el-icon-plus add-btn"></i>
      </div>
    </div>
    <!-- 新增多选赠酒sku -->
    <el-dialog
      class="select-dialog"
      title="新增赠酒SKU"
      :close-on-click-modal="false"
      :show-close="true"
      :visible.sync="dialogBeerVisible"
      width="950px"
    >
      <!-- 筛选条件 -->
      <div>
        <el-row>
          <el-col :span="20">
            <el-form class="dialog-form" ref="beer-form" :model="beerParams" :inline="true" label-width="100px">
              <el-form-item label="SKU编码" prop="skuCode">
                <el-input v-model="beerParams.skuCode" placeholder="请输入SKU编码" />
              </el-form-item>
              <el-form-item label="SKU名称" prop="skuName">
                <el-input v-model="beerParams.skuName" placeholder="请输入SKU名称" />
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="4" style="height:40px;line-height:40px">
            <el-button class="btn btn-red" size="small" @click="search()">搜索</el-button>
            <el-button class="btn btn-reset" size="small" @click="resetSearch()">重置</el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <el-table
        class="dialog-table"
        v-loading="beerLoading"
        ref="beerTable"
        :data="beerList"
        style="width: 100%;margin:20px 0;"
        :header-row-style="{ lineHeight: '30px'}"
        :header-row-class-name="hiddenCheckbox"
        border
        :row-key="beerRowKey"
        @select="getSelectBeer"
        @select-all="selectAllBeer"
        @selection-change="handleSelectionChange"
      >
        <el-table-column width="150" align="center" prop="skuCode" label="SKU编码" />
        <el-table-column align="center" prop="skuName" label="SKU名称" />
        <el-table-column align="center" type="selection" :reserve-selection="true" width="130" />
      </el-table>
      <el-row class="while-data-table-footer">
        <el-col>
          <el-pagination
            background
            :current-page="beerParams.page"
            :page-size="beerParams.pageSize"
            :total="total"
            layout="total, prev, pager, next"
            @current-change="handleCurrentChange"
          />
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button :loading="submitLoading" @click="dialogBeerVisible = false">取 消</el-button>
        <el-button :loading="submitLoading" type="danger" @click="handleAddBeer">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import PerfectBtnSelect from './perfect-btn-select.vue'
import tradeApi from '@/api/trade.js'
export default {
  props: {
    bonusBeerScope: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  components: {
    // PerfectBtnSelect
  },
  data () {
    return {
      dialogBeerVisible: false,
      beerParams: {
        page: 1,
        pageSize: 10,
        skuCode: '',
        skuName: '',
        brandCode: ''
      },
      brandCodeList: [],
      total: 0,
      beerLoading: false,
      submitLoading: false,
      beerList: [],
      selectList: [],
      selectedSku: '',
      cascaderProp: { expandTrigger: 'hover', value: 'brandCode', label: 'brandName', children: 'subBrandList' },
      options: [],
      selectedRows: '',
      selectProtocolId: ''
    }
  },
  watch: {
    bonusBeerScope () {
      this.selectedSku = Object.assign([], JSON.parse((this.bonusBeerScope || '[]')))
      this.selectList = Object.assign([], JSON.parse((this.bonusBeerScope || '[]')))
    }
  },
  created () {
    this.selectedSku = Object.assign([], JSON.parse((this.bonusBeerScope || '[]')))
    this.selectList = Object.assign([], JSON.parse((this.bonusBeerScope || '[]')))
  },
  methods: {
    // 展示弹框
    handleShowDialog (val) {
      this.dialogBeerVisible = true
      if (this.type !== 'bonusBeerSku') {
        this.selectList = [val]
      }
      this.search()
      if (this.selectedSku.length && this.beerList.length) {
        this.showBeerSelected()
      }
    },
    // 重置筛选条件
    resetSearch () {
      this.beerParams = this.$options.data().beerParams
      this.brandCodeList = []
      this.search()
    },
    // 搜索
    search () {
      this.beerParams.page = 1
      this.getBeerList()
    },
    // 获取完美门店赠酒SKU列表
    getBeerList () {
      if (this.type === 'bonusBeerSku') {
        this.beerParams.skuSource = 'SAP'
      } else {
        this.beerParams.skuSource = 'bees'
      }
      this.beerParams.isAbiOwn = 1
      this.beerLoading = true
      this.beerParams.skuCode = this.beerParams.skuCode.trim()
      this.beerParams.skuName = this.beerParams.skuName.trim()
      tradeApi.getStrSku(this.beerParams).then(res => {
        this.beerLoading = false
        if (res.data.resultCode === '0') {
          this.total = res.data.resultData.pageInfo.totalCounts
          this.beerList = res.data.resultData.skuList || []
          this.showBeerSelected()
        }
      })
        .catch(() => {
          this.beerLoading = false
        })
    },
    // sku弹窗每行标志位
    beerRowKey (row) {
      return row.skuCode
    },
    // 选择赠酒SKU
    getSelectBeer (selectList, row) {
      row.checked = true
      let flag = this.selectList.some((item) => {
        return item.skuCode === row.skuCode
      })
      if (flag) {
        this.selectList.forEach((item, index) => {
          if (item.skuCode === row.skuCode) {
            this.selectList.splice(index, 1)
          }
        })
      } else {
        this.selectList.push(row)
      }
      // this.sortBeerSelectList()
    },
    // 赠酒sku全选
    selectAllBeer (selectList) {
      selectList.forEach(item => {
        item.checked = true
      })
      this.selectList = Object.assign([], selectList)
      // this.sortBeerSelectList()
    },
    // sortBeerSelectList () {
    //   if (!this.selectList || this.selectList.length === 0) {
    //     return
    //   }
    //   this.selectList = this.selectList.sort((item1, item2) => {
    //     return parseInt(item1.skuId) - parseInt(item2.skuId)
    //   })
    // },
    // 赠酒SKU分页
    handleCurrentChange (val) {
      this.beerParams.page = val
      this.getBeerList()
    },
    // 新增赠酒SKU
    handleAddBeer () {
      if (this.type !== 'bonusBeerSku') {
        let obj = {}
        obj.skuCode = this.selectedRows[0].skuCode
        obj.skuName = this.selectedRows[0].skuName
        this.$emit('setBonusBeerSku', obj)
        this.selectedSku = this.selectedRows
        this.dialogBeerVisible = false
        return
      }
      let addList = []
      let deleteList = []
      if (!this.selectedSku) {
        this.selectedSku = []
      }

      // selectList里有，selectedSku里没有的元素  需新增
      addList = this.selectList.filter(selectedItem => {
        let checkedArr = this.selectedSku.map(
          checkedItem => checkedItem.skuCode
        )
        return !checkedArr.includes(selectedItem.skuCode)
      })
      // selectedSku里自定义有的，selectList里没有的  需删除
      deleteList = this.selectedSku.filter(checkedItem => {
        let selectedArr = this.selectList.map(
          selectedItem => selectedItem.skuCode
        )
        return (
          !selectedArr.includes(checkedItem.skuCode)
        )
      })

      // 将selectedSku没有的,selectList新增的box添加
      if (addList.length) {
        addList.map(item => {
          this.selectedSku.push({
            skuCode: item.skuCode,
            skuName: item.skuName
          })
        })
      }
      // 将selectList里没有的,selectedSku里删除
      if (deleteList.length) {
        deleteList.forEach(item => {
          let skuCodeList = this.selectedSku.map(item => {
            return item.skuCode
          })
          let index = skuCodeList.indexOf(item.skuCode)
          this.selectedSku.splice(index, 1)
        })
      }
      this.dialogBeerVisible = false
    },
    tableToggleRowSelection (index, boolean) {
      this.$refs.beerTable.toggleRowSelection(index, boolean)
    },
    // 删除选项
    // handleDeleteCheckbox (index, item) {
    //   // 获取删除选项在 selectList 中对应的对象
    //   let arr = this.selectList.filter(selectedItem => {
    //     if (item.skuCode === selectedItem.skuCode) {
    //       delete item.checked
    //     }
    //     return item.skuCode === selectedItem.skuCode
    //   })
    //   let selectedIndex = this.selectList.indexOf(arr[0])

    //   delete arr[0].checked
    //   this.$refs.beerTable.toggleRowSelection(arr[0], false)
    //   this.selectList.splice(selectedIndex, 1)
    // },
    // 获取赠酒sku数据
    // getBonusBeerScope (e, newDataList) {
    //   this.selectedSku = newDataList
    //   this.$emit('setValue', e)
    //   this.selectList = newDataList
    // },
    // 已勾选 表格对应展示
    showBeerSelected () {
      this.$nextTick(() => {
        this.beerList.map(beer => {
          const matchedBeer = this.selectList.find(selectedBeer => {
            return selectedBeer.skuCode === beer.skuCode
          })
          this.$refs.beerTable.toggleRowSelection(beer, Boolean(matchedBeer))
        })
      })
    },
    // 提交数据
    setValue () {
      // this.$refs.skuTypeScope.setValue()
    },
    // 删除
    handleDeleteBtn (index, item) {
      this.selectedSku.splice(index, 1)
      this.selectList = this.selectedSku
    },
    handleSelectionChange (val) {
      // 若存在一条数据 再次点击 该函数会执行三次 若没有数据选中，执行一次
      // 第一次 选中状态 val中有两条数据 => 走if
      // 第二次 清空数据 val为空  => 不走if
      // 第三次 将最后一条数据设置为选中状态 val有一条数据 =>不走if
      if (this.type === 'bonusBeerSku') {
        return
      }
      this.selectedRows = val
      if (val.length > 1) {
        this.$refs.beerTable.clearSelection()
        this.$refs.beerTable.toggleRowSelection(val.pop())
      }
      if (val.length !== 0) {
        this.selectProtocolId = val[val.length - 1].id
      }
    },
    hiddenCheckbox (row) {
      if (this.type !== 'bonusBeerSku') {
        return 'hidden-checkbox'
      }
    }

  }
}
</script>

<style lang="scss" scoped>
// 弹窗
.select-dialog {
  .dialog-form {
    line-height: 1;
  }
  .dialog-table {
    ::v-deep .el-table__header-wrapper .el-checkbox__input::after {
      content: '全选';
      position: absolute;
      margin: 0 0 0 10px;
      font-weight: 700;
      color: rgb(144, 147, 153);
    }
  }
}
// 加号
.add-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  margin: 12px 0 0 0;
  border-radius: 10px;
  background-color: #409eff;
  color: #fff;
  cursor: pointer;
}

.btn-box {
  position: relative;
  line-height: 30px;
  margin: 8px 20px 0 0;
  .delete-btn {
    width: 20px;
    height: 20px;
    position: absolute;
    right: -11px;
    top: -7px;
    color: rgb(234, 84, 4);
    font-size: 16px;
    line-height: 20px;
    cursor: pointer;
    z-index: 999;
    text-align: center;
  }
}
::v-deep .hidden-checkbox .el-checkbox {
  display: none !important;
}
</style>
